<template>
  <div class="manager-detail-update-log">
    <div class="total-count-bar">
      <span class="count-icon">!</span>
      <span class="count-num">已变更{{ updateLogList.length }}条</span>
    </div>

    <div class="log-list-container">
      <div class="empty-box" v-if="updateLogList.length === 0">
        暂无数据
      </div>
      <div class="log-item" v-for="log in updateLogList" :key="log.id">
        <div class="log-icon">
          <img :src="logIcon" alt="" />
        </div>
        <div class="log-main">
          <div class="prop-item">
            <span class="prop-label">变更时间：</span>
            <span class="prop-value">{{ log.updateTime }}</span>
          </div>
          <div class="prop-item">
            <span class="prop-label">变更内容：</span>
          </div>
          <div class="update-item" v-for="item in log.logList" :key="item.id">
            <span class="row-name">{{ item.name }}</span>
            <span class="row-content">{{ `${item.oldValue || '(无)'} > ${item.newValue}` }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import logIcon from '@/assets/img/icon/manager-update-log.png'

export default {
  props: {
    detailData: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      logIcon,
      updateLogList: [],
    }
  },
  created() {
    let updateLogList = this.detailData.changeRecords || []
    let arr = []
    updateLogList.forEach(item => {
      let temp = {}
      for(let key in item) {
        temp.id = key
        temp.updateTime = item[key][0].createTime
        temp.logList = item[key]
      }
      arr.push(temp)
    })

    this.updateLogList = arr
  },
}
</script>

<style lang="less" scoped>
.manager-detail-update-log {
  margin: 0 auto;
  padding-top: 10px;
  padding-bottom: 40px;
  width: 90%;
  .total-count-bar {
    display: flex;
    align-items: center;
    padding: 7px 20px;
    margin-bottom: 10px;
    width: 100%;
    background-color: rgba(234, 240, 254, 1);
    .count-icon {
      margin-right: 10px;
      text-align: center;
      width: 15px;
      line-height: 15px;
      color: white;
      background-color: rgba(1, 192, 192, 1);
      border-radius: 50%;
    }
  }
  .log-list-container {
    max-height: calc(~'80vh - 214px');
    overflow-y: auto;
    padding-bottom: 20px;
  }
  .empty-box {
    text-align: center;
    width: 100%;
    height: 100px;
    line-height: 100px;
  }
  .log-item {
    display: flex;
    padding: 20px;
    border: 1px solid rgba(233, 233, 233, 1);
    border-radius: 2px;
    margin-bottom: 10px;
    &:last-of-type {
      margin-bottom: 0px;
    }
    .log-icon {
      margin-right: 20px;
      img {
        max-width: 40px;
        max-height: 40px;
      }
    }
    .log-main {
      flex: 1;
    }
    .prop-item {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      .prop-value {
        font-size: 16px;
        font-weight: bold;
      }
    }
    .update-item {
      display: flex;
      align-items: center;
      padding: 10px 20px;
      margin-bottom: 5px;
      background-color: rgba(246, 249, 254, 1);
      .row-name {
        display: block;
        width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .row-content {
        display: block;
        flex: 1;
        text-align: justify;
      }
    }
  }
}
</style>